import { Component, Input } from '@angular/core';
import { NetworkMember } from 'huddyapi';

@Component({
  selector: 'avatar',
  templateUrl: 'avatar.component.html',
  styleUrls: ["./avatar.component.scss"]
})
export class Avatar {
  @Input() text: string = '?';
  @Input() url: string;
  @Input() fullImage: boolean = false;
  @Input() forceBackground: boolean = false;
  @Input() disabled: boolean = false;
  @Input() noFill: boolean = false;
  @Input() grey: boolean = false;
  @Input() imageLoading: boolean = false;
  @Input() clickHandler: () => any;

  constructor() {}

  getColor() {
    return (this.grey || this.imageLoading) ? 'avatarColorGrey' : NetworkMember.getColorForName(this.text);
  }
}